module.exports = __webpack_public_path__ + "Pages-icon.50fae7ee8f6d0467d5c4.ttf";


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.ttf?-u69vo5
// module id = ../../../../../src/assets/plugins/calendar/fonts/pages-icon/Pages-icon.ttf?-u69vo5
// module chunks = styles